import { useEffect } from 'react';
import type { AppId } from './apps';

const dirty = new Set<AppId>();
export const hasUnsavedChanges = (id?: AppId) => id ? dirty.has(id) : dirty.size > 0;
export function useUnsavedWindow(id: AppId, changed: boolean) {
  useEffect(() => {
    if (changed) dirty.add(id); else dirty.delete(id);
    return () => { dirty.delete(id); };
  }, [id,changed]);
}
